/**
 * Result type for domain errors. CLAUDE.md §2.4 and §17.1.
 *
 * Clinical functions return `Result` rather than throwing or returning a silent
 * default. A silently-defaulted glucose value is indistinguishable from a real
 * one at the call site, which is precisely the failure mode §16.3 forbids.
 *
 * Exceptions remain reserved for programmer errors (§17.1).
 */
export const ok = (value) => ({ ok: true, value });
export const err = (error) => ({ ok: false, error });
export const domainError = (code, message, context) => (context === undefined ? { code, message } : { code, message, context });
export const fail = (code, message, context) => err(domainError(code, message, context));
export const isOk = (r) => r.ok;
export const isErr = (r) => !r.ok;
export const map = (r, f) => r.ok ? ok(f(r.value)) : r;
export const flatMap = (r, f) => r.ok ? f(r.value) : r;
/**
 * Deliberately explicit: reading a value out of a Result requires naming the
 * fallback, so a caller cannot forget that the computation may not have produced
 * a number.
 */
export const unwrapOr = (r, fallback) => (r.ok ? r.value : fallback);
/** Collects a list of Results into a Result of a list, failing on the first error. */
export const all = (results) => {
    const values = [];
    for (const r of results) {
        if (!r.ok)
            return r;
        values.push(r.value);
    }
    return ok(values);
};
//# sourceMappingURL=result.js.map